// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ILockboxEntityMatchDto
 */
export interface ILockboxEntityMatchDto {
    /**
     * 
     * @type {number}
     * @memberof ILockboxEntityMatchDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILockboxEntityMatchDto
     */
    organization_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILockboxEntityMatchDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILockboxEntityMatchDto
     */
    claim_id?: number;
    /**
     * 
     * @type {Set<string>}
     * @memberof ILockboxEntityMatchDto
     */
    label_types?: Set<ILockboxEntityMatchDtoLabelTypesEnum>;
}

/**
* @export
* @enum {string}
*/
export enum ILockboxEntityMatchDtoLabelTypesEnum {
    FULL_MATCH = 'FULL_MATCH',
    ACCOUNT_NOT_MATCHED = 'ACCOUNT_NOT_MATCHED',
    SSN_NOT_MATCHED = 'SSN_NOT_MATCHED',
    EMPLOYEE_NAME_NOT_MATCHED = 'EMPLOYEE_NAME_NOT_MATCHED',
    ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
    LINKED_EMPLOYEE = 'LINKED_EMPLOYEE',
    ADDRESS_NOT_MATCHED = 'ADDRESS_NOT_MATCHED',
    COMMUNICATION_NOT_MATCHED = 'COMMUNICATION_NOT_MATCHED',
    AMOUNT_NOT_MATCHED = 'AMOUNT_NOT_MATCHED'
}


/**
 * Check if a given object implements the ILockboxEntityMatchDto interface.
 */
export function instanceOfILockboxEntityMatchDto(value: object): value is ILockboxEntityMatchDto {
    return true;
}

export function ILockboxEntityMatchDtoFromJSON(json: any): ILockboxEntityMatchDto {
    return ILockboxEntityMatchDtoFromJSONTyped(json, false);
}

export function ILockboxEntityMatchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILockboxEntityMatchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'label_types': json['label_types'] == null ? undefined : new Set(json['label_types']),
    };
}

export function ILockboxEntityMatchDtoToJSON(json: any): ILockboxEntityMatchDto {
    return ILockboxEntityMatchDtoToJSONTyped(json, false);
}

export function ILockboxEntityMatchDtoToJSONTyped(value?: ILockboxEntityMatchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'organization_id': value['organization_id'],
        'account_id': value['account_id'],
        'claim_id': value['claim_id'],
        'label_types': value['label_types'] == null ? undefined : Array.from(value['label_types'] as Set<any>),
    };
}

